import { Injectable } from '@angular/core';
import { AppointmentDemandList } from '../business-entities/appointment-demand-list-view-model';
import { AppointmentJobDetailList } from '../business-entities/appointment-JobDetail-list-view-model';

@Injectable({ providedIn: 'root' })
export class EditAppointmentService {
  appointmentDetails: any;
  isEdit: boolean;
  isFromHistoricalWOTab: boolean; //Added this for historical work orders
  isFromVehicleHistoricalTab: boolean; //Added this for vehicle historical work orders
  brandCode: string;
  appointmentGuidOfSelectedWO: any; //Added this for historical work orders
  appointmentIdOfSelectedWO: any; //Added this for historical work orders
  checkInURL: string;
  trackerURL: string;
  isSSMEnabled: boolean;
  isRomnasEnabled: boolean;
  exportedJson: string;
  isExported: boolean;
  isTecRMIEnabled: boolean;
  selectedMainTabNumber: number;
  selectedChildTabNumber: number;
  isOpenByOtherUser: boolean = false;
  isLockFeatureEnabled: boolean = false;
  DemandWiseDocumentCountList: any[] = [];
  isPlanningDone: boolean = false;
  AppointmentGenericTabs: { id: number, label: string, route: string }[] = [];
  isDelete: boolean;
  appointmentDemandList:AppointmentDemandList[];
  appointmentJobDetailsList: AppointmentJobDetailList[]
  isMPOEnabled: boolean;
  isFromMpo?: boolean;
  exportedMpoData?: string;
    isDownloadOffer: boolean = false;
}
